export default __webpack_public_path__ + "9bdf0efb4fbe3e3f5953206b851b1370.png";